module.exports = __webpack_public_path__ + "img/金豐ai公版icon.5ff5495d.svg";